import { Box, Card, CardActions, CardContent, CardHeader, Typography } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { useState } from "react";
import GButton from "./gbutton";

function CampaignCard({ campaign }: { campaign: Campaign }) {
  const [pending, setPending] = useState(() => !!campaign.agentRequests.length);
  const client = useQueryClient();
  const request = useMutation((id: string) => axios.post(`/agent/campaigns/${id}/request`), {
    onSuccess() {
      setPending(true);
      client.invalidateQueries(["AGENT_DASHBOARD"]);
      client.invalidateQueries(["NEW_CAMPAIGNS"]);
    },
  });
  return (
    <Card
      style={{
        minWidth: 275,
      }}>
      <CardHeader
        title={campaign.name}
        titleTypographyProps={{
          fontSize: "16px",
          fontWeight: "bold",
        }}
      />
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {campaign.description}
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            justifyContent: "space-between",
            my: 2,
            flexWrap: "wrap",
          }}>
          <Typography variant="body2" color="text.secondary">
            {campaign.country.currencyCode?.toLocaleString()} {campaign.price} per submission
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <b>{campaign.maxAnswers?.toLocaleString() ?? "_"}</b> submissions required
          </Typography>
        </Box>
      </CardContent>
      <CardActions>
        {campaign.status === "Archived" ? (
          <GButton
            variant="outlined"
            fullWidth
            size="large"
            disabled
            sx={{
              textTransform: "none",
              // fontWeight: "bold",
            }}>
            Closed
          </GButton>
        ) : pending ? (
          <GButton
            variant="text"
            fullWidth
            size="large"
            color="warning"
            sx={{
              textTransform: "none",
            }}>
            Pending
          </GButton>
        ) : (
          <GButton
            onClick={() => request.mutate(campaign.id)}
            variant="text"
            fullWidth
            size="large"
            sx={{
              textTransform: "none",
            }}>
            I'm interested
          </GButton>
        )}
      </CardActions>
    </Card>
  );
}

export default CampaignCard;
